export const PAGES_AND_PATHS = {
  login: {
    pageName: 'LOGIN',
    pageInRouting: 'login',
    pagePath: '/login',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: false,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: false,
    pagePathWithoutParams: ['/login']
  },
  landingHome: {
    pageName: 'LANDING_HOME',
    pageInRouting: 'landing/home',
    pagePath: '/landing/home',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: false,
    showHeader: true,
    showFooter: true,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: false,
    pagePathWithoutParams: ['/landing/home']
  },
  landingAboutUs: {
    pageName: 'LANDING_ABOUT_US',
    pageInRouting: 'landing/about-us',
    pagePath: '/landing/about-us',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: false,
    showHeader: true,
    showFooter: true,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: false,
    pagePathWithoutParams: ['/landing/about-us']
  },
  landingBlog: {
    pageName: 'LANDING_BLOG',
    pageInRouting: 'landing/blogs',
    pagePath: '/landing/blogs',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: false,
    showHeader: true,
    showFooter: true,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: false,
    pagePathWithoutParams: ['/landing/blogs']
  },
  landingSingleBlog: {
    pageName: 'LANDING_SINGLE_BLOG',
    pageInRouting: 'landing/blogs/:blogId',
    pagePath: '/landing/blogs',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: false,
    showHeader: true,
    showFooter: true,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: false,
    pagePathWithoutParams: ['/landing/blogs']
  },
  landingForBusinesses: {
    pageName: 'LANDING_FOR_BUSINESSES',
    pageInRouting: 'landing/for-businesses',
    pagePath: '/landing/for-businesses',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: false,
    showHeader: true,
    showFooter: true,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: false,
    pagePathWithoutParams: ['/landing/for-businesses']
  },
  landingContact: {
    pageName: 'LANDING_CONTACT',
    pageInRouting: 'landing/contact',
    pagePath: '/landing/contact',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: false,
    showHeader: true,
    showFooter: true,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: false,
    pagePathWithoutParams: ['/landing/contact']
  },
  forgotPassword: {
    pageName: 'FORGOT_PASSWORD',
    pageInRouting: 'forgot-password',
    pagePath: '/forgot-password',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: false,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: false,
    pagePathWithoutParams: ['/forgot-password']
  },
  resetPassword: {
    pageName: 'RESET_PASSWORD',
    pageInRouting: 'reset-password/admin/:token',
    pagePath: '/reset-password/admin',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: false,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: true,
    needAuthentication: false,
    pagePathWithoutParams: ['/reset-password/admin']
  },
  privacyPolicy: {
    pageName: 'PRIVACY_POLICY',
    pageInRouting: 'landing/privacy-policy',
    pagePath: '/landing/privacy-policy',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: false,
    showHeader: true,
    showFooter: true,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: false,
    pagePathWithoutParams: ['/landing/privacy-policy']
  },
  termsOfUse: {
    pageName: 'TERMS_OF_USE',
    pageInRouting: 'landing/terms-of-use',
    pagePath: '/landing/terms-of-use',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: false,
    showHeader: true,
    showFooter: true,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: false,
    pagePathWithoutParams: ['/landing/terms-of-use']
  },
  settings: {
    pageName: 'SETTINGS',
    pageInRouting: 'settings',
    pagePath: '/settings',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/settings']
  },
  dashboard: {
    pageName: 'DASHBOARD',
    pageInRouting: 'dashboard',
    pagePath: '/dashboard',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/dashboard']
  },
  adminList: {
    pageName: 'ADMIN_LIST',
    pageInRouting: 'admin-list',
    pagePath: '/admin-list',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/admin-list']
  },
  userList: {
    pageName: 'USER_LIST',
    pageInRouting: 'user-list',
    pagePath: '/user-list',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/user-list']
  },
  businessList: {
    pageName: 'BUSINESS_LIST',
    pageInRouting: 'business-list/:categoryId',
    pagePath: '/business-list',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/business-list']
  },
  businessProfile: {
    pageName: 'BUSINESS_PROFILE',
    pageInRouting: 'business-profile/:id',
    pagePath: '/business-profile',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/business-profile']
  },
  priceListCategory: {
    pageName: 'PRICE_LIST_CATEGORY',
    pageInRouting: 'business-profile/:id/price-list-category/:categoryId',
    pagePath: '/business-profile/:id/price-list-category',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/business-profile/:id/price-list-category']
  },
  priceListCategoryItemCreate: {
    pageName: 'PRICE_LIST_CATEGORY_ITEM_CREATE',
    pageInRouting: 'business-profile/:id/price-list-category/:categoryId/item-create',
    pagePath: '/business-profile/:id/price-list-category/:categoryId/item-create',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/business-profile/:id/price-list-category/:categoryId/item-create']
  },
  priceListCategoryItemEdit: {
    pageName: 'PRICE_LIST_CATEGORY_ITEM_EDIT',
    pageInRouting: 'business-profile/:id/price-list-category/:categoryId/item/:itemId',
    pagePath: '/business-profile/:id/price-list-category/:categoryId/item',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/business-profile/:id/price-list-category/:categoryId/item']
  },
  priceList: {
    pageName: 'PRICE_LIST',
    pageInRouting: 'price-list',
    pagePath: '/price-list',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/price-list']
  },
  presents: {
    pageName: 'PRESENTS',
    pageInRouting: 'presents',
    pagePath: '/presents',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/presents']
  },
  singlePresent: {
    pageName: 'SINGLE_PRESENT',
    pageInRouting: 'presents/:id',
    pagePath: '/presents',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/presents']
  },
  createPresent: {
    pageName: 'CREATE_PRESENT',
    pageInRouting: 'presents/create',
    pagePath: '/presents/create',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/presents/create']
  },
  editPresent: {
    pageName: 'EDIT_PRESENT',
    pageInRouting: 'presents/edit/:id',
    pagePath: '/presents/edit',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/presents/edit']
  },
  singleReservation: {
    pageName: 'SINGLE_RESERVATION',
    pageInRouting: 'reservations/:reservationId',
    pagePath: '/reservations',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/reservations']
  },
  reservations: {
    pageName: 'RESERVATIONS',
    pageInRouting: 'reservations',
    pagePath: '/reservations',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/reservations']
  },
  invitations: {
    pageName: 'INVITATIONS',
    pageInRouting: 'invitations',
    pagePath: '/invitations',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/invitations']
  },
  notifications: {
    pageName: 'NOTIFICATIONS',
    pageInRouting: 'notifications',
    pagePath: '/notifications',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/notifications']
  },
  banners: {
    pageName: 'BANNERS',
    pageInRouting: 'banners',
    pagePath: '/banners',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/banners']
  },
  bannerCreate: {
    pageName: 'BANNERS',
    pageInRouting: 'banners/create',
    pagePath: '/banners/create',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/banners/create']
  },
  bannerEdit: {
    pageName: 'BANNERS',
    pageInRouting: 'banners/:id',
    pagePath: '/banners',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/banners']
  },
  pages: {
    pageName: 'PAGES',
    pageInRouting: 'pages/:id',
    pagePath: '/pages',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/pages']
  },
  faq: {
    pageName: 'FAQ',
    pageInRouting: 'faq',
    pagePath: '/faq',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/faq']
  },
  userProfile: {
    pageName: 'USER_PROFILE',
    pageInRouting: 'user-profile',
    pagePath: '/user-profile',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/user-profile']
  },
  adminBlogs: {
    pageName: 'ADMIN_BLOGS',
    pageInRouting: 'admin/admin-blogs',
    pagePath: '/admin/admin-blogs',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/admin/admin-blogs']
  },
  adminEditBlog: {
    pageName: 'ADMIN_EDIT_BLOG',
    pageInRouting: 'admin/edit-blogs/:blogId',
    pagePath: '/admin/edit-blogs',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/admin/edit-blogs']
  },
  adminUserExperiences: {
    pageName: 'ADMIN_USER_EXPERIENCE',
    pageInRouting: 'admin/user-experiences',
    pagePath: '/admin/user-experiences',
    showTab: false,
    inTab: false,
    tabIcon: null,
    showSideMenu: true,
    showHeader: false,
    showFooter: false,
    isChild: false,
    parent: null,
    pageHaveParams: false,
    needAuthentication: true,
    pagePathWithoutParams: ['/admin/user-experiences']
  }
};

export const DEFAULT_AUTHENTICATED_PAGE = {
  page: PAGES_AND_PATHS.dashboard
};
